module.exports = __webpack_public_path__ + "img/cross-circle.7deb3e00.svg";